import React from 'react'
import { ContentInner } from '../layout/Content'
import TodaysSales from './components/todayssales/TodaysSales'

function DashboardInner() {
  return (
    <ContentInner>
      <TodaysSales />
    </ContentInner>
  )
}

export default React.memo(DashboardInner)
